import { Button, Paper, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { TabId } from "../../../services/api/types/portalConfiguration/translations";
import { gray } from "../../../theme/themePrimitives";
import { TranslationTabSection } from "./components/TranslationTabSection/TranslationTabSection";
import { usePageMetadata } from "../../../context/PageMetadataContext";

interface PortalTranslationProps {}

const tabs: { id: TabId; label: string }[] = [
  { id: "appFrame", label: "App Frame" },
  { id: "home", label: "Home" },
  { id: "login", label: "Login" },
  { id: "forgot-password", label: "Forgot password" },
  { id: "new-password", label: "New-password" },
  { id: "portal-configuration", label: "Portal configuration" },
  { id: "portal-design", label: "Portal design" },
  { id: "portal-pages", label: "Portal pages" },
  { id: "portal-settings", label: "Portal setting" },
  { id: "user-attributes", label: "User attributes" },
  { id: "portal-translation", label: "Portal translation" },
];

const appFrameTabs = ["Main menu", "Admin portal menu", "Navbar"] as const;
const homeTabs = ["Header", "Assignements"] as const;
const loginTabs = ["Login Header", "Login Form"] as const;
const forgotPasswordTabs = [
  "Forgot Password Header",
  "Forgot Password Form",
  "Forgot Password Info",
] as const;
const newPasswordTabs = [
  "Set New Password Header",
  "Set New Password Form",
  "Password Reset",
] as const;
const portalConfigurationTabs = [
  "Header",
  "Portal Grid",
  "Add Portal Modal",
  "Edit Languages",
] as const;
const portalDesignTabs = ["GPC", "Home", "Login"] as const;
const portalTranslationTabs = ["General"] as const;
const portalPagesTabs = ["Header", "Pages"] as const;
const portalSettingsTabs = ["Header", "Portal Settings"] as const;
const userAttributesTabs = [
  "Header",
  "User Attributes Grid",
  "User Attribute Modal",
] as const;

const tabsMap = [
  appFrameTabs,
  homeTabs,
  loginTabs,
  forgotPasswordTabs,
  newPasswordTabs,
  portalConfigurationTabs,
  portalDesignTabs,
  portalPagesTabs,
  portalSettingsTabs,
  userAttributesTabs,
  portalTranslationTabs,
] as const;

export const PortalTranslation: React.FC<PortalTranslationProps> = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { portalUid } = useParams();
  const currentTabs = tabsMap[activeTab];
  const handleTabChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  usePageMetadata({
    title: "Portal Translation",
    breadcrumbs: [
      {
        label: "Portal configuration",
        path: `/portal-configuration`,
      },
      {
        label: "Portal translation",
      },
    ],
  });

  return (
    <Paper>
      <Button
        component={Link}
        to={`/portal-configuration/${portalUid}/portal-translation/find-and-replace`}
        variant="outlined"
      >
        Find & Replace
      </Button>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: "unset",
          borderBottom: `1px solid ${gray[200]}`,
        }}
      >
        {tabs.map((t, index) => (
          <Tab key={index} label={t.label} />
        ))}
      </Tabs>
      <TranslationTabSection
        tabSection={tabs[activeTab].id}
        tabs={currentTabs}
      />
    </Paper>
  );
};
